import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";
import { AxiosPromise } from "axios";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CORE_SERVER_PREFIX}/monitoring-dashboard`
const endpoints = {
    cropData: () => `${RESOURCE_ENDPOINT}/production-monitor`,
    targetMonitor: () => `${RESOURCE_ENDPOINT}/target-monitor`,
}

export default class MonitoringDashboardApi {
    public cropData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.cropData();
        return HttpService.get(url, params, headers);
    };

    public targetMonitor = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.targetMonitor();
        return HttpService.get(url, params, headers);
    };
}
